// BannerGeneratorButton — dash-329 · Track B (passo 1)
//
// Botão "Gerar Banner" na ficha da peça que abre o BannerEditor num modal.
// Segue o mesmo padrão do PartPrintButton (botão → modal reactstrap → ação).
// O editor só monta quando o modal está aberto (o Fabric precisa do <canvas>
// no DOM antes de inicializar).

import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

import BannerEditor from "./BannerEditor";
import "./banner-generator.css";

const BannerGeneratorButton = ({
  part,
  companyLogoUrl,
  className = "tp-btn-banner",
  label = "Gerar Banner",
}) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={() => setOpen(true)}
        disabled={!part}
        title="Gerar criativo para redes sociais"
      >
        <i className="bi bi-image" />
        <span>{label}</span>
      </button>

      <Modal
        isOpen={open}
        toggle={close}
        centered
        size="xl"
        className="tp-banner-modal"
      >
        <ModalHeader toggle={close}>
          Gerar Banner · {part?.namePartPT || "Peça"}
        </ModalHeader>
        <ModalBody>
          {open && (
            <BannerEditor part={part} companyLogoUrl={companyLogoUrl} />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default BannerGeneratorButton;
